import React, { useState } from "react";
import "./style.scss";
import axios from "axios";

export default function ActionPopup({
  showPopup = false,
  link = "",
  category = "",
  onClose = () => {},
}) {
  function download(file, link) {
    //creating an invisible element
    var element = document.createElement("a");
    element.setAttribute("href", link);

    element.setAttribute("target", "_blank");
    element.setAttribute("download", file);

    // Above code is equivalent to
    // <a href="path of file" download="file name">

    document.body.appendChild(element);

    //onClick property
    element.click();

    document.body.removeChild(element);
  }

  const [values, setValues] = useState({
    email: "",
    firstName: "",
    lastName: "",
  });

  function handleInputChange(e) {
    setValues({ ...values, [e.target.name]: e.target.value });
  }

  async function onsubmit(e) {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://eclipsemattress.in/api/public/index.php/brochure-download",
        { ...values, category }
      );
      download("brochure.pdf", link);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div className={`actionpopup ${showPopup && "actionpopup--active"}`}>
      <p>Please enter the following details to download the brochure</p>
      <button onClick={onClose} className="actionpopup__close">
        <i class="fas fa-times"></i>
      </button>
      <form onSubmit={onsubmit} className="actionpopup__form">
        <div className="row">
          <div className="col-6">
            <input
              name="firstName"
              value={values.firstName}
              className="actionpopup__form__input"
              onChange={handleInputChange}
              placeholder="First Name"
              required
            ></input>
          </div>
          <div className="col-6">
            <input
              name="lastName"
              value={values.lastName}
              className="actionpopup__form__input"
              onChange={handleInputChange}
              placeholder="Last Name"
              required
            ></input>
          </div>
        </div>
        <input
          name="email"
          value={values.email}
          className="actionpopup__form__input"
          onChange={handleInputChange}
          placeholder="Email Address"
          required
        ></input>

        <button className="actionpopup__form__submit">
          Download <i class="fas fa-download"></i>
        </button>
      </form>
    </div>
  );
}
